module.exports = __webpack_public_path__ + "img/微信图片_20230206145629.ae57fb1d.jpg";